exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".browser[data-v-f6b813be]{background-color:#fff}.title-text[data-v-f6b813be]{text-transform:uppercase;font-weight:800}.message[data-v-f6b813be]{white-space:pre-wrap;font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f6b813be","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NonPublished.vue
// module id = bjAa
// module chunks = 0